import { formatDate } from '../../services/utils/DateUtils';
import { FilterItemBrandResource, FilterItemResource, MinMaxFilter } from '../FilterTypes';

export type ServiceFilterResource = {
  maxBps: number;
  minBps: number;
  years: FilterItemResource[];
  makes: FilterItemBrandResource[];
  models: FilterItemResource[];
  trims: FilterItemResource[];
  salesPersons: FilterItemResource[];
  serviceAdvisors: FilterItemResource[];
  roStatuses: FilterItemResource[];
  interactionStatuses: FilterItemResource[];
  dealTypes: FilterItemResource[];
  emailValidationStatus: FilterItemResource[];
  optOutPreference: FilterItemResource[];
};

export type ServiceSelectedFilterResource = {
  bpsValue: MinMaxFilter<number>;
  years: FilterItemResource[];
  makes: FilterItemBrandResource[];
  models: FilterItemResource[];
  isTrimConfirmationRequired: boolean;
  trims: FilterItemResource[];
  salesPersons: FilterItemResource[];
  serviceAdvisors: FilterItemResource[];
  roStatuses: FilterItemResource[];
  interactionStatuses: FilterItemResource[];
  dealTypes: FilterItemResource[];
  dateRange: MinMaxFilter<number>;
  emailValidationStatus: FilterItemResource;
  optOutPreference: FilterItemResource[];
};

export const defaultRange: MinMaxFilter<number> = { min: null, max: null };

export const appointmentsMinDate: Date = new Date(); //today
export const appointmentsMaxDate: Date = new Date(new Date().setDate(new Date().getDate() + 14)); //next 14 days
export const recentMinDate: Date = new Date(new Date().setDate(new Date().getDate() - 45)); //yesterday - 45 days
export const recentMaxDate: Date = new Date(new Date().setDate(new Date().getDate() - 1)); //yesterday

export const appointmentsDefaultFromDate: Date = new Date(formatDate(new Date())); //today
export const appointmentsDefaultToDate: Date = new Date(
  formatDate(new Date(new Date().setDate(new Date().getDate() + 7))),
); //next 7 days
export const recentDefaultFromDate: Date = new Date(
  formatDate(new Date(new Date().setDate(new Date().getDate() - 7))),
); //yesterday - 7 days
export const recentDefaultToDate: Date = new Date(
  formatDate(new Date(new Date().setDate(new Date().getDate() - 1))),
); //yesterday

export const appointmentsDefaultDateRangeValue: MinMaxFilter<number> = {
  min: -7,
  max: 0,
}; //today to next 14 days
export const recentsDefaultDateRangeValue: MinMaxFilter<number> = {
  min: 1,
  max: 7,
}; //yesterday - 7 days to yesterday
